import React, { Component } from 'react';
import './NavigationItem.css';
// import classes from './NavigationItem.css';

class navigationItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <li className="NavigationItem">
        <a href={this.props.link} id={this.props.navId}>
          {this.props.children}
        </a>
      </li>
    );
  }
}

export default navigationItem;



// WEBPACK FOOTER //
// ./src/components/Header/NavigationItems/NavigationItem/NavigationItem.js